import { Stack, TextField } from '@mui/material';

import Form from 'components/Form';

import { IFormRegister } from '../type';

interface Props extends IFormRegister {
  disabled?: boolean;
  isTestMode?: boolean;
}

function Remarks({ register, disabled, isTestMode }: Props) {
  const handlePreventEvent = (e: React.ClipboardEvent | React.MouseEvent) => {
    if (isTestMode) {
      e.preventDefault();
      e.stopPropagation();
    }
  };
  return (
    <Stack spacing={2}>
      <Form.Item label="Сувилахуйн үнэлгээ">
        <TextField
          fullWidth
          multiline
          minRows={2}
          size="small"
          variant="outlined"
          disabled={disabled}
          {...register('assessment')}
          onPaste={handlePreventEvent}
          onCopy={handlePreventEvent}
          onContextMenu={handlePreventEvent}
        />
      </Form.Item>

      <Form.Item label="Сувилахуйн онош">
        <div style={{ height: 'auto', display: 'flex' }}>
          <TextField
            sx={{ height: '60px', width: '360px' }}
            multiline
            minRows={1}
            maxRows={2}
            size="small"
            variant="outlined"
            disabled={disabled}
            {...register('diagnosisRelate')}
            onPaste={handlePreventEvent}
            onCopy={handlePreventEvent}
            onContextMenu={handlePreventEvent}
          />
          <div style={{ height: '30px', marginTop: '5px', marginLeft: 45 }}>
            <label>…-тай холбоотой</label>
          </div>
        </div>
        <TextField
          fullWidth
          multiline
          minRows={1}
          size="small"
          variant="outlined"
          disabled={disabled}
          {...register('diagnosis')}
          onPaste={handlePreventEvent}
          onCopy={handlePreventEvent}
          onContextMenu={handlePreventEvent}
        />
      </Form.Item>

      <Form.Item label="Сувилахуйн зорилго">
        <TextField
          fullWidth
          multiline
          minRows={2}
          size="small"
          variant="outlined"
          disabled={disabled}
          {...register('goal')}
          onPaste={handlePreventEvent}
          onCopy={handlePreventEvent}
          onContextMenu={handlePreventEvent}
        />
      </Form.Item>

      <Form.Item label="Сувилахуйн төлөвлөгөө">
        <TextField
          fullWidth
          multiline
          minRows={2}
          size="small"
          variant="outlined"
          disabled={disabled}
          {...register('plan')}
          onPaste={handlePreventEvent}
          onCopy={handlePreventEvent}
          onContextMenu={handlePreventEvent}
        />
      </Form.Item>

      <Form.Item label="Сувилахуйн хэрэгжүүлэлт / арга хэмжээ / онолын үндэслэл">
        <TextField
          fullWidth
          multiline
          minRows={2}
          size="small"
          variant="outlined"
          disabled={disabled}
          {...register('interventions')}
          onPaste={handlePreventEvent}
          onCopy={handlePreventEvent}
          onContextMenu={handlePreventEvent}
        />
      </Form.Item>

      <Form.Item label="Сувилахуйн үнэлгээ">
        <TextField
          fullWidth
          multiline
          minRows={2}
          size="small"
          variant="outlined"
          disabled={disabled}
          {...register('evaluation')}
          onPaste={handlePreventEvent}
          onCopy={handlePreventEvent}
          onContextMenu={handlePreventEvent}
        />
      </Form.Item>
    </Stack>
  );
}

export default Remarks;
